import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
class EdButtonToggle extends Vue {
  @Prop({ type: Array, required: true }) readonly options!: { label: string; value: string | number }[];
  @Prop({ type: [String, Number], required: true }) readonly value!: string | number;
  @Prop({ default: false, type: Boolean }) readonly rounded!: boolean;

  public readonly updateModel: string = 'updateModel';

  get buttonClasses() {
    return (optionValue: string | number) => ({
      'ed-button-toggle__ed-btn': true,
      'ed-button-toggle__ed-btn--active': optionValue === this.value,
    });
  }

  handleClick(optionValue: string | number) {
    this.$emit(this.updateModel, optionValue);
  }
}

export default Vue.component('ed-button-toggle', EdButtonToggle);
